<script lang="ts">
    import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row} from "sveltestrap";
    import FeatherIcon  from "svelte-feather-icon";
    import { AddBookmark, Cancel, Collection, Descriptions, Fs, General, Group, MyBookmarks, NewBookmark, Save, Titles, WebUrl } from "../../../utils/Constant/Constant";
    import {newBookmarkAdd} from "../../../store"
    type filterdata= {
        img: string;
        id: string;
        header: string;
        fillstar: boolean;
        link: string;
        content: string;
        title: string;
        class: string;
        class2: string;
    }[]
    let setNewBookmarkAdd:filterdata
    newBookmarkAdd.subscribe((value)=>{
        setNewBookmarkAdd = value
    })
    let newUrl:string
    let newTitle:string
    let open:boolean = false;
    const toggle = (e) => {
      e.preventDefault()
      open = !open
    }
    const handleNewBookmark = (e) => {
      e.preventDefault()
      let addValue = {
        "img":"01.jpg",
        "id":setNewBookmarkAdd.length,
        "header":newTitle,
        "fillstar":false,
        "link":newUrl,
        "content":"is beautifully crafted, clean and modern designed admin theme with 6 different demos and light - dark versions.",
        "title":"General",
        "class":"collection_0",
        "class2":"favourite_0"
      }
      newBookmarkAdd.update(value=> value = [...setNewBookmarkAdd,addValue])
      newUrl=""
      newTitle = ""
      open = !open
    }
</script>
<li class="nav-item">
  <Button class="badge-light btn-block btn-mail" on:click={toggle}>
    <FeatherIcon class="me-2" icon="bookmark"/> {NewBookmark}
  </Button>
</li>
<div class="fade modal-bookmark"  tabindex="-1"   aria-hidden="true">
    <Modal isOpen={open} {toggle} class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <ModalHeader >
          <h5 class="modal-title">{AddBookmark}</h5>
          <Button class="btn-close" on:click={toggle}></Button>
        </ModalHeader>
        <ModalBody>
          <Form class="form-bookmark needs-validation"  >
            <div class="form-row">
              <FormGroup>
                <Col md="12">
                  <Label for="bm-weburl">{WebUrl}</Label>
                  <Input id="bm-weburl" type="text" bind:value={newUrl} required autocomplete="off"/>
                </Col>
              </FormGroup> 
              <FormGroup> 
                <Col md="12">
                  <Label for="bm-title">{Titles}</Label>
                  <Input id="bm-title" type="text" bind:value={newTitle} required autocomplete="off"/>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col md="12">
                  <Label>{Descriptions}</Label>
                  <textarea class="form-control" id="bm-desc" required autocomplete="off"></textarea>
                </Col>
              </FormGroup>
              <Row>
                <FormGroup>
                  <Col md="6">
                      <Label>{Group}</Label>
                      <Input type="select" name="select" id="exampleSelect" value="My Bookmarks">
                          <option>{MyBookmarks}</option>
                      </Input>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col md="6">
                      <Label>{Collection}</Label>
                      <Input type="select" name="select" id="exampleSelect" value="General">
                          <option>{General}</option>
                          <option>{Fs}</option>
                      </Input>
                  </Col>
                </FormGroup>
              </Row>
            </div>
            <Input id="index_var" value="6"/>
            <Button color="secondary" on:click={(e)=>handleNewBookmark(e)}>{Save}</Button>
            <Button color="primary" on:click={(e)=>toggle(e)}>{Cancel}</Button>
          </Form>
        </ModalBody>
      </div>
    </Modal>
</div>